function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useState } from 'react';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
const MIN_YEAR = 2021;
const MAX_YEAR = dayjs().year();
export default function YearRangeFilter({ onChange }) {
    const _useState = useState({
        mode: 'month',
        year: dayjs().year(),
        month: dayjs().month() + 1
    }), _useState2 = _slicedToArray(_useState, 2), period = _useState2[0], setPeriod = _useState2[1];
    const emit = next => {
        setPeriod(next);
        onChange(next);
    };
    const handleOnChange = mode => {
        if (mode === 'year') {
            emit({
                mode: 'year',
                year: period.mode === 'year' || period.mode === 'month' ? period.year : period.endYear,
                gender: period.gender
            });
            return;
        }
        if (mode === 'month') {
            emit({
                mode: 'month',
                year: period.mode === 'year' || period.mode === 'month' ? period.year : period.endYear,
                month: period.mode === 'month' ? period.month : dayjs().month() + 1,
                gender: period.gender
            });
            return;
        }
        emit({
            mode: 'all',
            startYear: MIN_YEAR,
            endYear: MAX_YEAR,
            gender: period.gender
        });
    };
    const handleYearChange = d => {
        if (!d)
            return;
        emit({
            mode: 'year',
            year: d.year(),
            gender: period.gender
        });
    };
    const handleMonthChange = d => {
        if (!d)
            return;
        emit({
            mode: 'month',
            year: d.year(),
            month: d.month() + 1,
            gender: period.gender
        });
    };
    const handleStartYearChange = d => {
        if (!d || period.mode !== 'all')
            return;
        const nextStartYear = d.year();
        emit({
            mode: 'all',
            startYear: nextStartYear,
            endYear: nextStartYear > period.endYear ? nextStartYear : period.endYear,
            gender: period.gender
        });
    };
    const handleEndYearChange = d => {
        if (!d || period.mode !== 'all')
            return;
        const nextEndYear = d.year();
        emit({
            mode: 'all',
            startYear: nextEndYear < period.startYear ? nextEndYear : period.startYear,
            endYear: nextEndYear,
            gender: period.gender
        });
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-4 w-fit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: () => handleOnChange('all'),
        className: period.mode === 'all' ? '!bg-[#f0c52a36]' : ''
    }, "\u5168\u671F\u9593"), /*#__PURE__*/ React.createElement(Button, {
        onClick: () => handleOnChange('month'),
        className: period.mode === 'month' ? '!bg-[#f0c52a36]' : ''
    }, "\u6708")), period.mode === 'year' && /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "year",
        value: dayjs(`${period.year}-01-01`),
        allowClear: false,
        disabledDate: c => {
            if (!c)
                return false;
            const y = c.year();
            return y < MIN_YEAR || y > MAX_YEAR;
        },
        onChange: handleYearChange
    }), period.mode === 'month' && /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "month",
        value: dayjs(`${period.year}-${period.month}-01`),
        format: "YYYY-MM",
        allowClear: false,
        disabledDate: c => {
            if (!c)
                return false;
            return c > dayjs().endOf('month');
        },
        onChange: handleMonthChange
    }), period.mode === 'all' && /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-2"
    }, /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "year",
        value: dayjs(`${period.startYear}-01-01`),
        allowClear: false,
        disabledDate: c => {
            if (!c)
                return false;
            const y = c.year();
            return y < MIN_YEAR || y > MAX_YEAR;
        },
        onChange: handleStartYearChange
    }), /*#__PURE__*/ React.createElement("span", null, "\u301C"), /*#__PURE__*/ React.createElement(DatePicker, {
        picker: "year",
        value: dayjs(`${period.endYear}-01-01`),
        allowClear: false,
        disabledDate: c => {
            if (!c)
                return false;
            const y = c.year();
            return y < MIN_YEAR || y > MAX_YEAR;
        },
        onChange: handleEndYearChange
    })));
}
